const endpoints = {
  guests: {
    pricing: {
      index: {
        method: "get",
        url: "/api/guests/pricing",
      },
    },
    payments: {
      create: {
        method: "post",
        url: "/api/guests/payments",
      },
      capture: {
        method: "post",
        url: "/api/guests/payments/capture",
      },
    },
  },
}

export default endpoints
